var AdaptiveImage = require( "../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js" );

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "37c53984a82d7afeba0ca560a8f2ab4b.png",
    width: 156,
    height: 156
});